define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/ticketHeader.tmpl"),
        Button = require("ui/button/Button"),
        TicketHeaderView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketHeaderView = Marionette.ItemView.extend({
            template: template,
            className: 'ticket-header-view',
            ui: {
                backToListBtn: ".back-to-list-button",
                createNewBtn: ".create-new-container",
                backImage: ".back-to-list-image-container .back-to-list-image"
            },

            uiComponents: {
                backToListBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.backToListBtn",
                        permutation: Button.PERMUTATION.LIGHT_BLUELINK,
                        tooltip: LE.translator.translate("LEConnection.cases.ticketTab.actionExtended.ToolTip")
                    },
                    events: {
                        "click": "_onClickListButton"
                    }
                },
                createNewBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.createNewBtn",
                        permutation: Button.PERMUTATION.BTN,
                        text:LE.translator.translate("LEConnection.cases.ticketTab.actionNew.Text"),
                        tooltip:LE.translator.translate("LEConnection.cases.ticketTab.actionNew.ToolTip")
                    },
                    events: {
                        "click": "_createNew"
                    }
                }
            },

            initialize: function (options) {
                this.contextModel = (options) ? options.context : {};
                this.isCreateCaseVisible = options.isCreateCaseVisible;
                this.ticketTabChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_TAB);
                this._bindEvents();
            },

            onRender: function () {
                this._changeListButtonToOpen();
                if (!this.isCreateCaseVisible) {
                    this.ui.createNewBtn.hide();
                }
            },

            _bindEvents: function () {
                this.listenTo(this.contextModel,"change:extendedViewIsOpen",this._onExtendedViewStateChange);
            },

            _onClickListButton: function () {
                this.ticketTabChannel.vent.trigger("show:extendedList");
            },

            _createNew: function () {
                this.ticketTabChannel.vent.trigger("TicketTabController::createTicket:display");
            },

            _onExtendedViewStateChange: function(){
                this.extendedViewIsOpen = this._getExtendedViewIsOpen();
                if(this.extendedViewIsOpen) {
                    this._changeListButtonToClose();
                } else {
                    this._changeListButtonToOpen();
                }
            },

            _changeListButtonToOpen: function () {
                this.uiComponents.backToListBtn.setText(LE.translator.translate("LEConnection.cases.ticketTab.openFullList"));
                this.ui.backImage.removeClass("is-opened");
            },

            _changeListButtonToClose: function () {
                this.uiComponents.backToListBtn.setText(LE.translator.translate("LEConnection.cases.ticketTab.closeFullList"));
                this.ui.backImage.addClass("is-opened");
            },

            _getExtendedViewIsOpen: function(){
                return (this.contextModel) ? this.contextModel.get("extendedViewIsOpen") : false;
            }
        });
    });
    return TicketHeaderView;
});
